module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/dummy-fac1-9d31f9f23fbef206edd0963d1821a85b.jpg";